// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1G5PZ","title":"ClientInsurance_title__2SXD2","itemText":"ClientInsurance_itemText__3aCe_"};